'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var projectView = function projectView() {
  return import('@/page/project');
};
var projectList = function projectList() {
  return import('@/page/project/project-list');
};
var projectDetail = function projectDetail() {
  return import('@/page/project/project-detail');
};
var courseDetail = function courseDetail() {
  return import('@/page/course/course-detail');
};
var classResourse = function classResourse() {
  return import('@/page/project/class-menu/resourse');
};
var classMaillist = function classMaillist() {
  return import('@/page/project/class-menu/maillist');
};
var onLineCertificate = function onLineCertificate() {
  return import('@/page/project/class-menu/certificate');
};
var classCertificate = function classCertificate() {
  return import('@/page/project/class-menu/certificate');
};
var classAlbum = function classAlbum() {
  return import('@/page/project/class-menu/album');
};
var certificateDetail = function certificateDetail() {
  return import('@/page/project/class-menu/certificate-detail');
};
var communicationDetail = function communicationDetail() {
  return import('@/page/project/project-detail/communication-detail');
};
var classAssessment = function classAssessment() {
  return import('@/page/project/class-menu/assessment');
};

exports.default = [{
  path: '/project',
  name: 'peoject',
  component: projectView,
  children: [{
    path: 'project-list',
    name: 'project-list',
    component: projectList
  }, {
    path: 'project-detail',
    name: 'project-detail',
    component: projectDetail
  }, {
    path: 'project-assessment',
    name: 'project-assessment',
    component: classAssessment
  }, {
    path: 'course-detail',
    name: 'course-detail',
    component: courseDetail
  }, {
    path: 'onLine-certificate-project',
    name: 'onLine-certificate-project',
    component: onLineCertificate
  }, {
    path: 'project-resourse',
    name: 'project-resourse',
    component: classResourse
  }, {
    path: 'project-maillist',
    name: 'project-maillist',
    component: classMaillist
  }, {
    path: 'class-certificate-project',
    name: 'class-certificate-project',
    component: classCertificate
  }, {
    path: 'project-album',
    name: 'project-album',
    component: classAlbum
  }, {
    path: 'certificate-detail-project',
    name: 'certificate-detail-project',
    component: certificateDetail
  }, {
    path: 'communication-detail-project',
    name: 'communication-detail-project',
    component: communicationDetail
  }]
}];